<template>
    <div>
        <form>
            <label>
                <span>Topic</span>
                <input v-model="parameters.topic">
            </label>
            <label>
                <span>Description</span>
                <textarea v-model="parameters.description"/>
            </label>
            <label>
                <span>Author</span>
                <input v-model="parameters.author">
            </label>
            <label>
                <span>Minimum Slides</span>
                <input type="number" v-model="parameters.minimumSlides">
            </label>
            <label>
                <span>Maximum Slides</span>
                <input type="number" v-model="parameters.maximumSlides">
            </label>
<!--            <label>-->
<!--                <span>Model</span>-->
<!--                <select v-model="parameters.model">-->
<!--                    <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>-->
<!--                    <option value="gpt-4-1106-preview">gpt-4-1106-preview</option>-->
<!--                </select>-->
<!--            </label>-->
            <button @click.prevent="generate()">Generate</button>
<!--            {{ generatingStatus.status }}-->
        </form>
        <input type="color" v-model="style.backgroundTitle"/>
        <input type="color" v-model="style.background"/>
        <select v-model="style.fontFamily">
            <option value="arial">Arial</option>
            <option value="calibri">Calibri</option>
            <option value="Times new roman">Times New Roman</option>
            <option value="Consolas">Consolas</option>
        </select>
        <slides-preview :xml="preview" :style="styleFull" @changeXml="onSlidesChange"
                        :slidesChangeSymbol="slidesChangeSymbol"/>

        <label>
            <span>Format</span>
            <select v-model="parameters.format">
                <option value="pptx">PPTX</option>
                <option value="ppt">ppt</option>
                <option value="odp">ODP</option>
                <option value="pdf">pdf</option>
            </select>
        </label>
        <button @click.prevent="download()">Download</button>
    </div>
</template>

<script>
import SlidesPreview from "@/components/SlidesPreview.vue";
import Color from "colorjs.io";
import ReactivePromiseStatus from "reactive-promise-status/dist/reactive-promise-status";

export default {
    name: 'HelloWorld',
    components: {
        SlidesPreview
    },
    data() {
        return {
            style: {
                backgroundTitle: '#ffffff',
                background: '#ffffff',
                fontFamily: 'arial'
            },
            preview: null,
            generatingStatus: new ReactivePromiseStatus(),
            slidesChangeSymbol: Symbol()
        }
    },
    methods: {
        onSlidesChange(xml) {
            this.preview = xml;
            this.slidesChangeSymbol = Symbol();
        }
    },
    computed: {
        styleFull() {
            const background = new Color(this.style.background);
            const color = background.luminance > 0.4 ? '#000000' : '#ffffff';
            const backgroundTitle = new Color(this.style.backgroundTitle);
            const colorTitle = backgroundTitle.luminance > 0.4 ? '#000000' : '#ffffff';
            return {
                ...this.style,
                color, colorTitle
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
form label {
    display: block;
}
</style>
